export default {
  setProjects(state, projects) {
    state.projects = projects;
  },
  setProject(state, project) {
    state.project = project;
  },
  setTasks(state, tasks) {
    state.tasks = tasks;
  },
  setTask(state, task) {
    state.task = task;
  },
  setTaskStatuses(state, taskStatuses) {
    state.taskStatuses = taskStatuses;
  },
  setSelectedRow(state, value) {
    state.selectedRow = value;
  },
  currentPage(state, value) {
    return (state.currentPage = value);
  },
  paginationTotal(state, value) {
    return (state.total = value);
  },
  perPage(state, value) {
    return (state.perPage = value);
  },
  searchQuery(state, value) {
    return (state.searchQuery = value);
  },
  tableLoading(state, value) {
    return (state.tableLoading = value);
  },
  resetState(state) {
    state.currentPage = 1;
    state.perPage = 5;
    state.searchQuery = "";
    state.total = 0;
  },
};
